module.exports = "/assets/images/ico-card.4e0fbe27.png";